const getValidToken = (token) => {
  try {
    const tokenArr = token.split('.');
    const aToken = tokenArr.length === 0 ? '' : tokenArr[1];
    const decoded = window.atob(aToken);
    if (decoded) {
      const decodedObj = JSON.parse(decoded);
      return decodedObj.sub;
    }
    return '';
  } catch (err) {
    return '';
  }
};

export default getValidToken;
